<script lang="ts">
	import { format } from 'svelte-i18n';
	import { Text, ButtonV2, Button } from '@Shelly/shelly-design-system';
	import { user_data } from 'src/stores/account/user';
	import { currentUnitId, homes } from 'src/stores/account/home';
	import HomeAvatar from 'src/components/Homes/HomeAvatar.svelte';
	import EditHomeModal from 'src/components/Homes/EditHomeModal.svelte';
	import { showNewLayout } from 'src/stores/toDelete/new_layout';
	import { findOwnedHome } from 'src/helpers/houses/homes_helpers';

	let showEditModal = false;

	$: currentHome = $homes.list.find((home) => home.id === $currentUnitId);
	$: isInstaller = $user_data.installer;
	$: displayHome = isInstaller
		? findOwnedHome(
				$homes.list,
				String($user_data.user_id),
				$user_data?.available_units ?? {},
				$currentUnitId,
			)
		: currentHome;

	$: fallbackName = ($user_data?.available_units ?? {})[$currentUnitId] ?? '';
	$: currentHomeName = displayHome?.name || fallbackName;
</script>

<div class="d-flex flex-direction-column">
	<div class="d-flex align-items-center">
		<HomeAvatar home={displayHome} size="l" class="mr-m" />
		<div class="d-flex flex-direction-column flex-1 min-width-0">
			<Text class="width-full" element="p" styleType="body" noWrap>
				{currentHomeName}
			</Text>
			<Text class="width-full text-color-muted" element="p" styleType="body-small" noWrap>
				ID:{$currentUnitId}
			</Text>
		</div>
	</div>
	<div class="mt-m">
		{#if $showNewLayout}
			<ButtonV2
				class="width-md-auto width-sm-full"
				variant="secondary"
				size="m"
				icon="fas fa-pen"
				disabled={!currentHome}
				aria-label={$format('edit_home', { default: 'Edit home' })}
				on:click={() => (showEditModal = true)}
			>
				{$format('edit_home', { default: 'Edit home' })}
			</ButtonV2>
		{:else}
			<Button
				class="width-md-auto width-sm-full"
				variant="secondary"
				size="m"
				icon="fas fa-pen"
				disabled={!currentHome}
				aria-label={$format('edit_home', { default: 'Edit home' })}
				on:click={() => (showEditModal = true)}
			>
				{$format('edit_home', { default: 'Edit home' })}
			</Button>
		{/if}
	</div>
</div>

{#if currentHome}
	<EditHomeModal bind:showModal={showEditModal} home={currentHome} />
{/if}
